<template>
	<div class="content-section-b" id="work">
		<div class="container">
			<div class="row">
				<div class="col-lg-12">
					<h2 class="section-heading">My Work</h2>
					<!-- <p class="lead">
						I keep my vector design skills fresh, translating to crisp color
						palletes, intelligent layout, and a delightful use of shapes.
					</p> -->
				</div>
			</div>
			<div class="row mt-2">
				<div class="col-sm-6 col-md-4">
					<a
						target="_blank"
						href="https://github.com/rioparmar1996/expert-potato"
					>
						<img
							id="scale"
							src="https://mir-s3-cdn-cf.behance.net/project_modules/max_3840/7823cc45224441.5829e88f95dfa.png"
							alt="..."
							class="img-thumbnail"
						/>
					</a>
				</div>
				<div class="col-sm-4 col-md-4">
					<a target="_blank" href="https://github.com/rioparmar1996/recipeApp">
						<img
							id="scale"
							src="https://mir-s3-cdn-cf.behance.net/project_modules/max_3840/20d7f444397567.581175cd607f6.png"
							alt="..."
							class="img-thumbnail"
						/>
					</a>
				</div>

				<div class="col-sm-4 col-md-4">
					<a
						id="scale"
						target="_blank"
						href="https://github.com/rioparmar1996/cuddly-octo-giggle"
					>
						<img
							id="scale"
							src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/827672/background.png"
							alt="..."
							class="img-thumbnail"
						/>
					</a>
				</div>
			</div>
			<div class="row mt-4">
				<div class="col-md-3">
					<a
						target="_blank"
						href="https://github.com/rioparmar1996/thefirstavenger"
					>
						<img
							id="scale"
							src="https://mir-s3-cdn-cf.behance.net/project_modules/max_3840/ee935444971773.582d4dfb815e3.png"
							alt="..."
							class="img-thumbnail"
						/>
					</a>
				</div>
				<div class="col-md-3">
					<a target="_blank" href="https://github.com/rioparmar1996/quizApp">
						<img
							id="scale"
							src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/827672/caveback.png"
							alt="..."
							class="img-thumbnail"
						/>
					</a>
				</div>
				<div class="col-md-3">
					<a
						target="_blank"
						href="https://github.com/rioparmar1996/musicplayer"
					>
						<img
							id="scale"
							src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/827672/logo%20room.png"
							alt="..."
							class="img-thumbnail"
						/>
					</a>
				</div>
				<div class="col-md-3">
					<a
						target="_blank"
						href="https://github.com/rioparmar1996/countDownClock"
					>
						<img
							id="scale"
							src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/827672/pub.png"
							alt="..."
							class="img-thumbnail"
						/>
					</a>
				</div>
			</div>
			<a target="_blank" href="https://codepen.io/rioparmar1996"
				><button
					id="button"
					class="animated infinite pulse btn btn-success btn-lg mt-4 mx-5"
				>
					<i class="icon fab fa-codepen" aria-hidden="true"></i> See on CodePen
				</button></a
			>
			<a target="_blank" href="https://github.com/rioparmar1996"
				><button
					id="button"
					class="animated infinite pulse btn btn-success btn-lg mt-4 mx-5"
				>
					<i class="icon fab fa-github" aria-hidden="true"></i> See more GitHub
				</button></a
			>
		</div>
		<!-- /.container -->
	</div>
</template>
<style scoped>
.content-section-b {
	padding: 50px 0;
	background: linear-gradient(
		rgba(18%, 67%, 98%, 0.75),
		rgba(18%, 67%, 98%, 0.85)
	);
	text-align: center;
	color: white;
}

#scale:hover {
	-moz-transform: scale(1.1);
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
	transition-duration: 1s;
}

#button {
	color: white;
	font-size: 24px;
	margin-top: 30px;
	border: solid 6px white;
	background: #65ce9b;
	padding: 15px;
	text-transform: uppercase;
	font-weight: 500;
}
</style>
